import { AutogenLayoutSetStateLocalTaxCode } from "./autogen/AutogenLayoutSetStateLocalTaxCode";

export class SetStateLocalTaxCode extends AutogenLayoutSetStateLocalTaxCode {
    onLoad(): void | Promise<void> {
      
    }
}
